import { complement, filter, join, map, pipe, zip } from 'ramda'
import snakecaseKeys from 'snakecase-keys'

import { ASC, DESC, Sorting, SortingDirection, UNSET } from '../types/sorting'

export const isAsc = (sorting: SortingDirection) => sorting === ASC

export const isDesc = (sorting: SortingDirection) => sorting === DESC

export const isUnset = (sorting: SortingDirection) => sorting === UNSET

export const getNextSortingDirection = (sort: SortingDirection) => {
  if (sort === ASC) return DESC
  if (sort === DESC) return UNSET
  return ASC
}

export const snakecaseKey = (key: string) =>
  Object.keys(snakecaseKeys({ [key]: 0 }))[0]

export const djangoSerializeSorting = (sorting: Sorting) => {
  type S1 = [string, SortingDirection] // pair [key, direction]
  type S2 = [string, string] // pair [key, direction] where `direction` is django serialized

  const removeUnset = filter(complement(isUnset))

  const keys = Object.keys(removeUnset(sorting))
  const vals = Object.values(removeUnset(sorting))

  // convert 'asc' and 'desc' to django syntax
  const toDirection = (sort: SortingDirection) => {
    if (isDesc(sort)) return '-'
    return ''
  }

  const zipKeyDirection = (l1: string[], l2: SortingDirection[]) => zip(l1, l2)

  const serialize = pipe(
    zipKeyDirection,
    map<S1, S1>(([key, dir]) => [snakecaseKey(key), dir]),
    map<S1, S2>(([key, dir]) => [key, toDirection(dir)]),
    map<S2, string>(([key, dir]) => `${dir}${key}`),
    join(',')
  )

  const param = serialize(keys, vals)

  return param || undefined
}

export const serializeSorting = (sorting: Sorting): string | undefined =>
  djangoSerializeSorting(sorting)
